import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Button, InputTextArea, Modal, Text } from "@pentabd/ui";
import {
  ErrorModal,
  InputTextAreaRow,
  SelectController,
  SuccessModal,
} from "@components";

import { useProcurementFlow } from "@hooks/procurements/procurement/useProcurementFlow";
import { getConvertedMetaData } from "@helpers/inventory/metaDataConvert";
import {
  executeWorkflow,
  startWorkflow,
} from "@api/procurements/procurementWorkFlow";
import { ROUTES } from "@constants/routes";
import { DECISION_TYPE } from "@constants/workflow-decision-type";
import { useTranslation } from "react-i18next";

const { FORWARD } = DECISION_TYPE;

interface WorkFlowModalProps {
  isOpen: boolean;
  closeWorkFlowModal: () => void;
  procurementId: string | undefined;
  processInstanceId?: string;
  nextFileOnHandPositionCode?: string;
}

export default function WorkFlowModal({
  isOpen,
  closeWorkFlowModal,
  procurementId,
  processInstanceId,
  nextFileOnHandPositionCode,
}: WorkFlowModalProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { control, register, setValue, handleSubmit } = useForm();
  const { employees, handleQuery } = useProcurementFlow();

  console.log(employees);

  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    navigate(`${ROUTES.PROCUREMENT.PROCUREMENTS}`);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const onSubmit = async (data: any) => {
    closeWorkFlowModal();
    console.log(data);

    try {
      if (nextFileOnHandPositionCode) {
        const res = await executeWorkflow(
          procurementId as string,
          FORWARD,
          processInstanceId as string,
          data.nextFileOnHandId,
          data.comment,
        );
      } else {
        const res = await startWorkflow(
          procurementId as string,
          data.nextFileOnHandId,
        );
      }

      setIsSuccessModalOpen(true);
    } catch (error) {
      setIsErrorModalOpen(true);
    }
  };

  useEffect(() => {
    if (nextFileOnHandPositionCode) {
      handleQuery("positionCode", nextFileOnHandPositionCode);
    }
  }, [nextFileOnHandPositionCode]);

  return (
    <div>
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
      {/* modals end */}
      <Modal
        overlay={isOpen}
        isOpen={isOpen}
        onClose={closeWorkFlowModal}
        portal={isOpen}
      >
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-10 w-100">
            <div className="row">
              <div className="col-12">
                <Text weight="semibold" color="title" size="sm">
                  Select Employee
                </Text>
                <span className="text-danger">&#42;</span>
              </div>
              <div className="col-12">
                <SelectController
                  control={control}
                  name={"nextFileOnHandId"}
                  register={{ ...register("nextFileOnHandId") }}
                  options={getConvertedMetaData(employees)}
                  setValue={setValue}
                  portal
                  zIndexValue={8}
                />
              </div>
            </div>

            {nextFileOnHandPositionCode && (
              <div className="row">
                <div className="col-12">
                  <Text weight="semibold" color="title" size="sm">
                    {t("PROCUREMENT_CREATE.WORKFLOW_MODAL.FORM.COMMENT.LABEL")}
                  </Text>
                </div>
                <div className="col-12">
                  <InputTextArea
                    {...register("comment")}
                    name="comment"
                    placeholder={t(
                      "PROCUREMENT_CREATE.WORKFLOW_MODAL.FORM.COMMENT.PLACEHOLDER",
                    )}
                  />
                </div>
              </div>
            )}

            <div className="w-max mx-auto mt-10">
              <Button
                key="close"
                className="px-18"
                size="sm"
                htmlType="submit"
                fill="fill"
                type="primary"
              >
                {t("PROCUREMENT_CREATE.FORM.BUTTONS.SUBMIT")}
              </Button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
}
